// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.dw {
  color: #131d3f;
}

.bw {
  color: #4896a2;
}

.rw {
  color: #b01b5c;
}

.gw {
  color: #2980b9;
}

/* ===== 手機閱讀寬度優化 (≤768px) ===== */
@media (max-width: 768px) {
  /* 主要內容放寬：讓 w-50/w-75 吃滿寬，並加一點側邊內距 */
  .container .w-50,
  .container .w-75 {
    width: 100% !important;
    max-width: none !important;
  }
  .container {
    padding-left: 20px;
    padding-right: 20px;
  }
  /* ServiceNavbar：卡片改大，單卡≈8~9 成視窗寬，閱讀字不擠 */
  .servicenavbar {
    position: relative;
    top: 0;
    display: flex;
    flex-wrap: nowrap;
    justify-content: flex-start;
    gap: 16px;
    padding: 0 12px 14px;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    scroll-snap-type: x mandatory;
    touch-action: pan-x;
  }
  .servicenavbar > a {
    flex: 0 0 auto;
  }
  .servicesq {
    width: clamp(160px, 86vw, 220px);
    height: clamp(60px, 48vw, 140px);
    font-size: clamp(22px, 7vw, 34px);
    border-radius: 16px;
    scroll-snap-align: start;
  }
  .secsub {
    font-size: clamp(14px, 4vw, 18px);
  }
  /* 內文圖片、橫幅：等比滿寬，不要被擠小 */
  img,
  .banner img {
    max-width: 100%;
    width: 100%;
    height: auto;
    object-fit: contain;
    display: block;
  }
  /* 影片 16:9 自適應 */
  iframe {
    width: 100% !important;
    height: auto !important;
    aspect-ratio: 16/9;
  }
  /* 表格：不要強制最小寬造成內容區域看起來更窄；需要捲動時才橫捲 */
  .table-responsive {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
  .table {
    min-width: 0; /* 若之前有設定 560px，這裡覆蓋掉 */
  }
  /* 大間距收斂一點，避免內容看起來稀疏更顯窄 */
  .mt100 {
    margin-top: 56px !important;
  }
  .mb100 {
    margin-bottom: 56px !important;
  }
  .beckertitlename {
    margin: 40px 0 24px !important;
  }
}
@media (max-width: 768px) {
  .ea-banner { /* 保留上方空間 */
    display: block; /* 確保存在於文件流 */
    min-height: 140px; /* 依需要調整 120~180px 都可 */
    background: transparent;
  }
  .ea-banner img { /* 手機把圖藏起來 */
    display: none;
  }
}
.video-wrap {
  display: flex;
  justify-content: center;
}

/* 手機改成滿寬 16:9 */
@media (max-width: 768px) {
  .video-wrap iframe {
    width: 100% !important;
    height: auto !important;
    aspect-ratio: 16/9;
  }
}
/* 游標提示可放大（桌機/手機都可用） */
.zoomable {
  cursor: zoom-in;
}

/* 全螢幕檢視層 */
.lightbox {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.82);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  z-index: 2200;
}

.lightbox img {
  max-width: 100%;
  max-height: 90vh;
  object-fit: contain;
}

.lightbox-close {
  position: absolute;
  top: 10px;
  right: 14px;
  background: transparent;
  border: 0;
  color: #fff;
  font-size: 32px;
  line-height: 1;
  cursor: pointer;
}

/* 只想在手機才開放 lightbox？就這樣關掉桌機點擊 */
@media (min-width: 769px) {
  .zoomable {
    cursor: default;
    pointer-events: none;
  }
}
/* ---------- Scoped: only under #ea-page ---------- */
#ea-page {
  --brand:#b01b5c; /* primary */
  --accent:#ffc206; /* highlight */
  --navy:#131d3f; /* deep/navy */
  --bg:#ffffff;
  --ink:#535353; /* default text color */
  --muted:#6f6f6f;
  --border:#e5e5e5;
  --card:#fafafa;
  --ring:#fde17a;
  color: var(--ink);
  position: relative;
  font-family: ui-sans-serif, system-ui, -apple-system, "PingFang TC", "Noto Sans TC", "Microsoft JhengHei", Segoe UI, Roboto, Helvetica, Arial, "Apple Color Emoji", "Segoe UI Emoji";
}

#ea-page a {
  color: var(--navy);
  text-decoration: none;
}

#ea-page a:hover {
  text-decoration: underline;
}

#ea-page img {
  max-width: 100%;
  height: auto;
  border-radius: 12px;
}

/* ===== Top sticky band ===== */
#ea-page .topband {
  position: sticky;
  top: 0;
  z-index: 5;
  background: var(--navy);
  color: #fff;
  border-bottom: 1px solid rgba(255, 255, 255, 0.15);
  transition: filter 0.2s ease, box-shadow 0.2s ease;
}

#ea-page .topband:hover {
  filter: brightness(1.08);
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.15);
}

#ea-page .topband-inner {
  max-width: 1100px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 16px;
}

#ea-page .btw {
  font-weight: 800;
  letter-spacing: 0.2px;
  white-space: nowrap;
}

#ea-page .desc {
  opacity: 0.95;
  font-size: 14px;
  line-height: 1.4;
}

#ea-page .hi {
  color: var(--accent);
  font-weight: 800;
}

/* Layout */
#ea-page .container {
  max-width: 1100px;
  margin: 0 auto;
  padding: 20px;
}

#ea-page .shell {
  display: grid;
  grid-template-columns: 1fr;
  gap: 24px;
}

@media (min-width: 960px) {
  #ea-page .shell {
    grid-template-columns: 2.1fr 1fr;
  }
}
/* Hero */
#ea-page .hero {
  border: 1px solid var(--border);
  border-radius: 16px;
  padding: 28px;
  background: linear-gradient(180deg, rgba(255, 194, 6, 0.18), rgba(176, 27, 92, 0.06) 70%, transparent);
  margin-bottom: 20px;
}

#ea-page .hero h1 {
  margin: 0 0 10px;
  font-size: clamp(24px, 3vw, 36px);
  color: var(--navy);
}

#ea-page .hero .hero-kicker {
  margin: 0 0 6px;
  font-weight: 700;
  color: var(--brand);
}

#ea-page .hero p {
  margin: 0;
  color: var(--muted);
}

/* Article */
#ea-page article {
  border: 1px solid var(--border);
  border-radius: 16px;
  background: #fff;
  padding: 26px;
}

#ea-page article :is(h1, h2, h3) {
  scroll-margin-top: 100px;
  color: var(--navy);
}

#ea-page article h2 {
  font-size: clamp(20px, 2.2vw, 28px);
  margin: 22px 0 8px;
}

#ea-page article h3 {
  font-size: clamp(18px, 2vw, 22px);
  margin: 16px 0 6px;
}

#ea-page article p {
  line-height: 1.9;
  margin: 12px 0;
}

#ea-page article ul, #ea-page article ol {
  padding-left: 1.2em;
}

#ea-page article li {
  line-height: 1.85;
  margin: 6px 0;
}

#ea-page article blockquote {
  margin: 16px 0;
  padding: 16px 18px;
  background: rgba(255, 194, 6, 0.14);
  border-left: 4px solid var(--brand);
  border-radius: 10px;
  color: var(--ink);
}

/* Table - nice default + RWD wrapper */
#ea-page .table-wrap {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  border: 1px solid var(--border);
  border-radius: 12px;
  background: #fff;
  margin: 16px 0;
}

#ea-page .table-wrap > table {
  margin: 0;
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
}

#ea-page thead th {
  background: linear-gradient(180deg, rgba(19, 29, 63, 0.06), rgba(19, 29, 63, 0.02));
  color: var(--navy);
  text-align: left;
  font-weight: 700;
  padding: 12px 14px;
  border-bottom: 1px solid var(--border);
}

#ea-page td, #ea-page th {
  padding: 12px 14px;
  border-bottom: 1px solid var(--border);
  vertical-align: top;
}

#ea-page tr:last-child td {
  border-bottom: none;
}

/* Sidebar */
#ea-page .side {
  display: flex;
  flex-direction: column;
  gap: 18px;
}

#ea-page .card {
  background: #fff;
  border: 1px solid var(--border);
  border-radius: 16px;
  padding: 18px;
}

#ea-page .card h4 {
  margin: 0 0 8px;
  font-size: 16px;
  color: var(--navy);
  letter-spacing: 0.3px;
}

#ea-page .muted {
  color: var(--muted);
  font-size: 14px;
}

/* Pricing */
#ea-page .pricing {
  display: grid;
  grid-template-columns: 1fr;
  gap: 12px;
  margin-top: 8px;
}

#ea-page .price-item {
  border: 1px solid var(--border);
  border-radius: 14px;
  padding: 16px;
  background: var(--card);
}

#ea-page .pi-title {
  font-weight: 800;
  margin: 0 0 6px;
  color: var(--navy);
}

#ea-page .pi-line {
  margin: 4px 0 0;
}

#ea-page .badge {
  display: inline-block;
  padding: 6px 10px;
  border-radius: 999px;
  font-size: 12px;
  letter-spacing: 0.3px;
  background: var(--brand);
  color: #fff;
  font-weight: 800;
}

/* Buttons */
#ea-page .btn {
  appearance: none;
  border: 2px solid var(--brand);
  border-radius: 999px;
  padding: 10px 14px;
  background: #fff;
  color: var(--brand);
  cursor: pointer;
  font-weight: 700;
}

#ea-page .btn.btn-primary, #ea-page .btn-primary {
  background: var(--brand);
  color: #fff;
  border-color: var(--brand);
}

#ea-page .btn:focus {
  outline: 3px solid var(--ring);
  outline-offset: 2px;
}

/* Divider */
#ea-page .divider {
  height: 1px;
  background: var(--border);
  margin: 14px 0;
}

/* Media responsiveness */
#ea-page .embed {
  position: relative;
  width: 100%;
  padding-top: 56.25%;
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid var(--border);
  background: #000;
  margin: 12px 0;
}

#ea-page .embed iframe {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  border: 0;
}

/* -------- RWD Hardening -------- */
#ea-page {
  overflow-x: hidden;
}

#ea-page *, #ea-page *::before, #ea-page *::after {
  box-sizing: border-box;
}

/* Wrap long text / links */
#ea-page article :is(h1, h2, h3, p, li, td, th),
#ea-page .card,
#ea-page .hero p,
#ea-page a {
  overflow-wrap: anywhere;
  word-wrap: break-word;
  word-break: break-word;
}

/* Images/videos/iframes full width */
#ea-page img, #ea-page video, #ea-page iframe {
  max-width: 100% !important;
  height: auto;
}

/* Tables: fallback to horizontal scroll if needed */
#ea-page article table {
  display: block;
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

#ea-page article table th, #ea-page article table td {
  white-space: normal;
}

/* Kill inline fixed widths that could break RWD */
#ea-page [style*=min-width] {
  min-width: 0 !important;
}

#ea-page [style*="width: "], #ea-page [style*="width:"] {
  max-width: 100% !important;
}

/* Mobile paddings */
@media (max-width: 480px) {
  #ea-page .container {
    padding-left: 16px;
    padding-right: 16px;
  }
  #ea-page .hero {
    padding: 20px;
  }
  #ea-page article {
    padding: 18px;
  }
}
/* Single column under 960px */
@media (max-width: 959.98px) {
  #ea-page .shell {
    grid-template-columns: 1fr !important;
  }
}
/* ---------- Utilities for BS3 gaps we used ---------- */
#ea-page .u-w75 {
  max-width: 75%;
}

#ea-page .u-mx-auto {
  margin-left: auto;
  margin-right: auto;
}

/* Spacing helpers (since BS3 lacks mt-5 etc.) */
#ea-page .mt100 {
  margin-top: 100px;
}

#ea-page .mb100 {
  margin-bottom: 100px;
}

#ea-page .mt-5 {
  margin-top: 3rem;
}

#ea-page .w-100 {
  width: 100%;
}

/* 作用域變數：設定吸頂距離（導覽列 + topband 高度） */
#ea-page {
  --sticky-top: 80px; /* 依你的站上實際高度調整 */
}

/* 讓側欄在 grid 裡不要被置中拉扯，卡在頂部起始位置 */
#ea-page .side {
  align-self: start;
}

/* 真正 sticky 的容器（包住「目錄」和「聯絡我們」兩張卡） */
#ea-page .side-sticky {
  position: sticky;
  top: var(--sticky-top);
  max-height: calc(100vh - var(--sticky-top) - 16px);
  overflow: auto;
  -webkit-overflow-scrolling: touch;
}

/* 卡片間距 */
#ea-page .side-sticky .card + .card {
  margin-top: 14px;
}

/* 小螢幕時關掉 sticky（側欄通常會落到主文下方單欄顯示） */
@media (max-width: 959.98px) {
  #ea-page {
    --sticky-top: 0px;
  }
  #ea-page .side-sticky {
    position: static;
    max-height: none;
    overflow: visible;
  }
}
/* 關鍵：避免祖先誤設 overflow 影響 sticky。
   只允許 X 軸隱藏，Y 軸要保持可滾動 */
#ea-page {
  overflow-x: hidden; /* ✅ */
  /* 不要寫 overflow: hidden; 會害 sticky 失效 */
}

/* 若你的 .shell 是 CSS Grid，確保它本身沒有 overflow */
#ea-page .shell,
#ea-page .container {
  overflow: visible;
}

/* ====== Sticky Sidebar — 強制穩定版 ====== */
/* 1) 統一吸頂位移（導覽列 + topband 高度），沒有就用 80px */
#ea-page {
  --sticky-top: 80px;
}

/* 2) Grid 對齊到上緣，確保 sticky 起始點正確 */
#ea-page .shell {
  align-items: start;
}

/* 3) 讓 aside 本身就 sticky（比包一層 .side-sticky 更穩） */
#ea-page aside.side {
  position: sticky;
  top: var(--sticky-top, 80px);
  height: max-content; /* 高度以內容為主，避免被撐滿 */
  z-index: 2; /* 防止被內容覆蓋 */
}

/* 4) 側欄內容太長時，讓卡片本身滾動（可選） */
#ea-page aside.side .card + .card {
  margin-top: 14px;
}

#ea-page aside.side .card-wrap {
  display: flex;
  flex-direction: column;
  gap: 14px;
  max-height: calc(100vh - var(--sticky-top, 80px) - 16px);
  overflow: auto;
  -webkit-overflow-scrolling: touch;
}

/* 5) 避免祖先不小心設到破壞 sticky 的屬性 */
#ea-page,
#ea-page .container,
#ea-page .shell,
#ea-page article,
#ea-page .content {
  overflow: visible !important; /* 不能有 overflow: hidden/auto/scroll（Y 軸）*/
  transform: none !important; /* 不能有 transform 會中斷 sticky 參考 */
  will-change: auto !important; /* 避免外層被優化成獨立圖層 */
}

/* 手機單欄就關掉 sticky（側欄會掉到主文下方） */
@media (max-width: 959.98px) {
  #ea-page aside.side {
    position: static;
  }
  #ea-page aside.side .card-wrap {
    max-height: none;
    overflow: visible;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/ea/styles/ea.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACI,cAAA;AAEJ;;AAAA;EACI,cAAA;AAGJ;;AADA;EACI,cAAA;AAIJ;;AAFA;EACI,cAAA;AAKJ;;AAFA,kCAAA;AACA;EACI,oCAAA;EACA;;IAEE,sBAAA;IACA,0BAAA;EAKJ;EAHE;IACE,kBAAA;IACA,mBAAA;EAKJ;EAFE,yCAAA;EACA;IACE,kBAAA;IACA,MAAA;IACA,aAAA;IACA,iBAAA;IACA,2BAAA;IACA,SAAA;IACA,oBAAA;IACA,gBAAA;IACA,iCAAA;IACA,6BAAA;IACA,mBAAA;EAIJ;EAFE;IAAqB,cAAA;EAKvB;EAJE;IACE,gCAAA;IACA,gCAAA;IACA,iCAAA;IACA,mBAAA;IACA,wBAAA;EAMJ;EAJE;IAAU,iCAAA;EAOZ;EALE,uBAAA;EACA;;IAEE,eAAA;IACA,WAAA;IACA,YAAA;IACA,mBAAA;IACA,cAAA;EAOJ;EAJE,gBAAA;EACA;IACE,sBAAA;IACA,uBAAA;IACA,kBAAA;EAMJ;EAHE,mCAAA;EACA;IACE,gBAAA;IACA,iCAAA;EAKJ;EAHE;IACE,YAAA,EAAA,uBAAA;EAKJ;EAFE,yBAAA;EACA;IAAS,2BAAA;EAKX;EAJE;IAAS,8BAAA;EAOX;EANE;IAAmB,8BAAA;EASrB;AACF;AARE;EACE,aAAA,WAAA;IACE,cAAA,EAAA,aAAA;IACA,iBAAA,EAAA,uBAAA;IACA,uBAAA;EAUJ;EARE,iBAAA,YAAA;IACE,aAAA;EAUJ;AACF;AARA;EACI,aAAA;EACA,uBAAA;AAUJ;;AAPE,gBAAA;AACA;EACE;IACE,sBAAA;IACA,uBAAA;IACA,kBAAA;EAUJ;AACF;AAPE,sBAAA;AACF;EAAY,eAAA;AAUZ;;AARA,WAAA;AACA;EACE,eAAA;EACA,QAAA;EACA,+BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,aAAA;AAWF;;AATA;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;AAYF;;AAVA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,uBAAA;EACA,SAAA;EACA,WAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;AAaF;;AAVA,gCAAA;AACA;EACE;IAAY,eAAA;IAAiB,oBAAA;EAe7B;AACF;AAdA,sDAAA;AACA;EACE,eAAA,EAAA,YAAA;EACA,gBAAA,EAAA,cAAA;EACA,cAAA,EAAA,cAAA;EACA,YAAA;EACA,aAAA,EAAA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;EACA,oLAAA;AAgBF;;AAbA;EAAY,kBAAA;EAAmB,qBAAA;AAkB/B;;AAjBA;EAAkB,0BAAA;AAqBlB;;AApBA;EAAc,eAAA;EAAgB,YAAA;EAAa,mBAAA;AA0B3C;;AAxBA,gCAAA;AACA;EACE,gBAAA;EAAkB,MAAA;EAAQ,UAAA;EAC1B,uBAAA;EAAyB,WAAA;EACzB,kDAAA;EACA,kDAAA;AA8BF;;AA5BA;EAAyB,wBAAA;EAA0B,0CAAA;AAiCnD;;AAhCA;EACE,iBAAA;EAAkB,cAAA;EAClB,aAAA;EAAc,mBAAA;EAAoB,SAAA;EAAU,kBAAA;AAuC9C;;AArCA;EAAe,gBAAA;EAAiB,qBAAA;EAAqB,mBAAA;AA2CrD;;AA1CA;EAAgB,aAAA;EAAa,eAAA;EAAgB,gBAAA;AAgD7C;;AA/CA;EAAc,oBAAA;EAAsB,gBAAA;AAoDpC;;AAlDA,WAAA;AACA;EAAqB,iBAAA;EAAkB,cAAA;EAAe,aAAA;AAwDtD;;AAvDA;EAAiB,aAAA;EAAc,0BAAA;EAA2B,SAAA;AA6D1D;;AA5DA;EACE;IAAiB,gCAAA;EAgEjB;AACF;AA9DA,SAAA;AACA;EACE,+BAAA;EAAgC,mBAAA;EAAoB,aAAA;EACpD,sGAAA;EACA,mBAAA;AAkEF;;AAhEA;EAAmB,gBAAA;EAAiB,iCAAA;EAAgC,kBAAA;AAsEpE;;AArEA;EAA6B,eAAA;EAAgB,gBAAA;EAAiB,mBAAA;AA2E9D;;AA1EA;EAAkB,SAAA;EAAU,mBAAA;AA+E5B;;AA7EA,YAAA;AACA;EACE,+BAAA;EACA,mBAAA;EAAoB,gBAAA;EAAiB,aAAA;AAkFvC;;AAhFA;EAAgC,wBAAA;EAAyB,kBAAA;AAqFzD;;AApFA;EAAqB,mCAAA;EAAkC,kBAAA;AAyFvD;;AAxFA;EAAqB,iCAAA;EAAgC,kBAAA;AA6FrD;;AA5FA;EAAoB,gBAAA;EAAiB,cAAA;AAiGrC;;AAhGA;EAA0C,mBAAA;AAoG1C;;AAnGA;EAAqB,iBAAA;EAAkB,aAAA;AAwGvC;;AAtGA;EACE,cAAA;EAAe,kBAAA;EAAmB,mCAAA;EAClC,mCAAA;EAAoC,mBAAA;EAAoB,iBAAA;AA6G1D;;AA1GA,uCAAA;AACA;EACE,gBAAA;EAAiB,iCAAA;EACjB,+BAAA;EAAgC,mBAAA;EAAoB,gBAAA;EAAiB,cAAA;AAiHvE;;AA/GA;EAA8B,SAAA;EAAU,WAAA;EAAY,yBAAA;EAA0B,iBAAA;AAsH9E;;AArHA;EACE,mFAAA;EACA,kBAAA;EAAmB,gBAAA;EAAiB,gBAAA;EAAiB,kBAAA;EAAmB,sCAAA;AA4H1E;;AA1HA;EAA0B,kBAAA;EAAmB,sCAAA;EAAuC,mBAAA;AAgIpF;;AA/HA;EAA2B,mBAAA;AAmI3B;;AAjIA,YAAA;AACA;EAAgB,aAAA;EAAc,sBAAA;EAAuB,SAAA;AAuIrD;;AAtIA;EAAgB,gBAAA;EAAiB,+BAAA;EAAgC,mBAAA;EAAoB,aAAA;AA6IrF;;AA5IA;EAAmB,eAAA;EAAgB,eAAA;EAAgB,kBAAA;EAAmB,qBAAA;AAmJtE;;AAlJA;EAAiB,mBAAA;EAAoB,eAAA;AAuJrC;;AArJA,YAAA;AACA;EAAmB,aAAA;EAAc,0BAAA;EAA2B,SAAA;EAAU,eAAA;AA4JtE;;AA3JA;EAAsB,+BAAA;EAAgC,mBAAA;EAAoB,aAAA;EAAc,uBAAA;AAkKxF;;AAjKA;EAAoB,gBAAA;EAAiB,eAAA;EAAgB,kBAAA;AAuKrD;;AAtKA;EAAmB,eAAA;AA0KnB;;AAzKA;EAAiB,qBAAA;EAAsB,iBAAA;EAAkB,oBAAA;EAAqB,eAAA;EAAgB,qBAAA;EAAqB,wBAAA;EAAyB,WAAA;EAAY,gBAAA;AAoLxJ;;AAlLA,YAAA;AACA;EAAe,gBAAA;EAAiB,8BAAA;EAA+B,oBAAA;EAAqB,kBAAA;EAAmB,gBAAA;EAAiB,mBAAA;EAAoB,eAAA;EAAgB,gBAAA;AA6L5J;;AA5LA;EAAkD,wBAAA;EAAyB,WAAA;EAAY,0BAAA;AAkMvF;;AAjMA;EAAqB,8BAAA;EAA+B,mBAAA;AAsMpD;;AApMA,YAAA;AACA;EAAmB,WAAA;EAAY,yBAAA;EAA0B,cAAA;AA0MzD;;AAxMA,yBAAA;AACA;EAAiB,kBAAA;EAAmB,WAAA;EAAY,mBAAA;EAAoB,mBAAA;EAAoB,gBAAA;EAAiB,+BAAA;EAAgC,gBAAA;EAAiB,cAAA;AAmN1J;;AAlNA;EAAwB,kBAAA;EAAmB,QAAA;EAAS,WAAA;EAAY,YAAA;EAAa,SAAA;AA0N7E;;AAxNA,oCAAA;AACA;EAAW,kBAAA;AA4NX;;AA3NA;EAAoD,sBAAA;AA+NpD;;AA7NA,2BAAA;AACA;;;;EAIE,uBAAA;EACA,qBAAA;EACA,sBAAA;AAgOF;;AA7NA,qCAAA;AACA;EACE,0BAAA;EACA,YAAA;AAgOF;;AA7NA,oDAAA;AACA;EAAyB,cAAA;EAAe,WAAA;EAAY,gBAAA;EAAiB,iCAAA;AAoOrE;;AAnOA;EAAuD,mBAAA;AAuOvD;;AArOA,kDAAA;AACA;EAAgC,uBAAA;AAyOhC;;AAxOA;EAA2D,0BAAA;AA4O3D;;AA1OA,oBAAA;AACA;EACE;IAAsB,kBAAA;IAAoB,mBAAA;EA+O1C;EA9OA;IAAiB,aAAA;EAiPjB;EAhPA;IAAmB,aAAA;EAmPnB;AACF;AAjPA,8BAAA;AACA;EACE;IAAkB,qCAAA;EAoPlB;AACF;AAlPA,yDAAA;AACA;EAAkB,cAAA;AAqPlB;;AApPA;EAAsB,iBAAA;EAAkB,kBAAA;AAyPxC;;AAvPA,gDAAA;AACA;EAAkB,iBAAA;AA2PlB;;AA1PA;EAAkB,oBAAA;AA8PlB;;AA7PA;EAAiB,gBAAA;AAiQjB;;AAhQA;EAAkB,WAAA;AAoQlB;;AAnQA,mCAAA;AACA;EACE,kBAAA,EAAA,gBAAA;AAsQF;;AAnQA,gCAAA;AACA;EACE,iBAAA;AAsQF;;AAnQA,oCAAA;AACA;EACE,gBAAA;EACA,sBAAA;EACA,kDAAA;EACA,cAAA;EACA,iCAAA;AAsQF;;AAnQA,SAAA;AACA;EACE,gBAAA;AAsQF;;AAnQA,mCAAA;AACA;EACE;IACE,iBAAA;EAsQF;EApQA;IACE,gBAAA;IACA,gBAAA;IACA,iBAAA;EAsQF;AACF;AAnQA;wBAAA;AAEA;EACE,kBAAA,EAAA,MAAA;EACA,uCAAA;AAqQF;;AAlQA,2CAAA;AACA;;EAEE,iBAAA;AAqQF;;AAnQA,yCAAA;AACA,0CAAA;AACA;EAAW,kBAAA;AAuQX;;AArQA,kCAAA;AACA;EAAkB,kBAAA;AAyQlB;;AAvQA,gDAAA;AACA;EACE,gBAAA;EACA,4BAAA;EACA,mBAAA,EAAA,kBAAA;EACA,UAAA,EAAA,YAAA;AA0QF;;AAvQA,2BAAA;AACA;EAAoC,gBAAA;AA2QpC;;AA1QA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,wDAAA;EACA,cAAA;EACA,iCAAA;AA6QF;;AA1QA,8BAAA;AACA;;;;;EAKE,4BAAA,EAAA,yCAAA;EACA,0BAAA,EAAA,gCAAA;EACA,4BAAA,EAAA,iBAAA;AA6QF;;AA1QA,8BAAA;AACA;EACE;IACE,gBAAA;EA6QF;EA3QA;IACE,gBAAA;IACA,iBAAA;EA6QF;AACF","sourcesContent":[".dw{\r\n    color:#131d3f;\r\n}\r\n.bw {\r\n    color:#4896a2;\r\n}\r\n.rw {\r\n    color:#b01b5c;\r\n}\r\n.gw {\r\n    color:#2980b9;\r\n}\r\n\r\n/* ===== 手機閱讀寬度優化 (≤768px) ===== */\r\n@media (max-width: 768px) {\r\n    /* 主要內容放寬：讓 w-50/w-75 吃滿寬，並加一點側邊內距 */\r\n    .container .w-50,\r\n    .container .w-75 {\r\n      width: 100% !important;\r\n      max-width: none !important;\r\n    }\r\n    .container {\r\n      padding-left: 20px;\r\n      padding-right: 20px;\r\n    }\r\n  \r\n    /* ServiceNavbar：卡片改大，單卡≈8~9 成視窗寬，閱讀字不擠 */\r\n    .servicenavbar{\r\n      position: relative;\r\n      top: 0;\r\n      display: flex;\r\n      flex-wrap: nowrap;\r\n      justify-content: flex-start;\r\n      gap: 16px;\r\n      padding: 0 12px 14px;\r\n      overflow-x: auto;\r\n      -webkit-overflow-scrolling: touch;\r\n      scroll-snap-type: x mandatory;\r\n      touch-action: pan-x;\r\n    }\r\n    .servicenavbar > a { flex: 0 0 auto; }\r\n    .servicesq{\r\n      width: clamp(160px, 86vw, 220px);\r\n      height: clamp(60px, 48vw, 140px);\r\n      font-size: clamp(22px, 7vw, 34px);\r\n      border-radius: 16px;\r\n      scroll-snap-align: start;\r\n    }\r\n    .secsub { font-size: clamp(14px, 4vw, 18px); }\r\n  \r\n    /* 內文圖片、橫幅：等比滿寬，不要被擠小 */\r\n    img,\r\n    .banner img {\r\n      max-width: 100%;\r\n      width: 100%;\r\n      height: auto;\r\n      object-fit: contain;\r\n      display: block;\r\n    }\r\n  \r\n    /* 影片 16:9 自適應 */\r\n    iframe {\r\n      width: 100% !important;\r\n      height: auto !important;\r\n      aspect-ratio: 16/9;\r\n    }\r\n  \r\n    /* 表格：不要強制最小寬造成內容區域看起來更窄；需要捲動時才橫捲 */\r\n    .table-responsive {\r\n      overflow-x: auto;\r\n      -webkit-overflow-scrolling: touch;\r\n    }\r\n    .table {\r\n      min-width: 0; /* 若之前有設定 560px，這裡覆蓋掉 */\r\n    }\r\n  \r\n    /* 大間距收斂一點，避免內容看起來稀疏更顯窄 */\r\n    .mt100 { margin-top: 56px !important; }\r\n    .mb100 { margin-bottom: 56px !important; }\r\n    .beckertitlename { margin: 40px 0 24px !important; }\r\n  }\r\n  @media (max-width: 768px) {\r\n    .ea-banner {           /* 保留上方空間 */\r\n      display: block;      /* 確保存在於文件流 */\r\n      min-height: 140px;   /* 依需要調整 120~180px 都可 */\r\n      background: transparent;\r\n    }\r\n    .ea-banner img {       /* 手機把圖藏起來 */\r\n      display: none;\r\n    }\r\n  }\r\n.video-wrap {\r\n    display: flex;\r\n    justify-content: center;\r\n  }\r\n  \r\n  /* 手機改成滿寬 16:9 */\r\n  @media (max-width: 768px) {\r\n    .video-wrap iframe {\r\n      width: 100% !important;\r\n      height: auto !important;\r\n      aspect-ratio: 16/9;\r\n    }\r\n  }\r\n\r\n  /* 游標提示可放大（桌機/手機都可用） */\r\n.zoomable { cursor: zoom-in; }\r\n\r\n/* 全螢幕檢視層 */\r\n.lightbox {\r\n  position: fixed;\r\n  inset: 0;\r\n  background: rgba(0,0,0,.82);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 16px;\r\n  z-index: 2200;\r\n}\r\n.lightbox img {\r\n  max-width: 100%;\r\n  max-height: 90vh;\r\n  object-fit: contain;\r\n}\r\n.lightbox-close {\r\n  position: absolute;\r\n  top: 10px;\r\n  right: 14px;\r\n  background: transparent;\r\n  border: 0;\r\n  color: #fff;\r\n  font-size: 32px;\r\n  line-height: 1;\r\n  cursor: pointer;\r\n}\r\n\r\n/* 只想在手機才開放 lightbox？就這樣關掉桌機點擊 */\r\n@media (min-width: 769px) {\r\n  .zoomable { cursor: default; pointer-events: none; }\r\n}\r\n/* ---------- Scoped: only under #ea-page ---------- */\r\n#ea-page {\r\n  --brand:#b01b5c;      /* primary */\r\n  --accent:#ffc206;     /* highlight */\r\n  --navy:#131d3f;       /* deep/navy */\r\n  --bg:#ffffff;\r\n  --ink:#535353;        /* default text color */\r\n  --muted:#6f6f6f;\r\n  --border:#e5e5e5;\r\n  --card:#fafafa;\r\n  --ring:#fde17a;\r\n  color:var(--ink);\r\n  position: relative;\r\n  font-family: ui-sans-serif,system-ui,-apple-system,\"PingFang TC\",\"Noto Sans TC\",\"Microsoft JhengHei\",Segoe UI,Roboto,Helvetica,Arial,\"Apple Color Emoji\",\"Segoe UI Emoji\";\r\n}\r\n\r\n#ea-page a{ color:var(--navy); text-decoration:none; }\r\n#ea-page a:hover{ text-decoration:underline; }\r\n#ea-page img{ max-width:100%; height:auto; border-radius:12px; }\r\n\r\n/* ===== Top sticky band ===== */\r\n#ea-page .topband{\r\n  position: sticky; top: 0; z-index: 5;\r\n  background: var(--navy); color: #fff;\r\n  border-bottom: 1px solid rgba(255,255,255,.15);\r\n  transition: filter .2s ease, box-shadow .2s ease;\r\n}\r\n#ea-page .topband:hover{ filter: brightness(1.08); box-shadow: 0 2px 10px rgba(0,0,0,.15); }\r\n#ea-page .topband-inner{\r\n  max-width:1100px; margin:0 auto;\r\n  display:flex; align-items:center; gap:12px; padding:10px 16px;\r\n}\r\n#ea-page .btw{ font-weight:800; letter-spacing:.2px; white-space:nowrap; }\r\n#ea-page .desc{ opacity:.95; font-size:14px; line-height:1.4; }\r\n#ea-page .hi{ color: var(--accent); font-weight: 800; }\r\n\r\n/* Layout */\r\n#ea-page .container{ max-width:1100px; margin:0 auto; padding:20px; }\r\n#ea-page .shell{ display:grid; grid-template-columns:1fr; gap:24px; }\r\n@media (min-width: 960px){\r\n  #ea-page .shell{ grid-template-columns:2.1fr 1fr; }\r\n}\r\n\r\n/* Hero */\r\n#ea-page .hero{\r\n  border:1px solid var(--border); border-radius:16px; padding:28px;\r\n  background:linear-gradient(180deg, rgba(255,194,6,.18), rgba(176,27,92,.06) 70%, transparent);\r\n  margin-bottom:20px;\r\n}\r\n#ea-page .hero h1{ margin:0 0 10px; font-size:clamp(24px,3vw,36px); color:var(--navy); }\r\n#ea-page .hero .hero-kicker{ margin:0 0 6px; font-weight:700; color:var(--brand); }\r\n#ea-page .hero p{ margin:0; color:var(--muted); }\r\n\r\n/* Article */\r\n#ea-page article{\r\n  border:1px solid var(--border);\r\n  border-radius:16px; background:#fff; padding:26px;\r\n}\r\n#ea-page article :is(h1,h2,h3){ scroll-margin-top:100px; color:var(--navy); }\r\n#ea-page article h2{ font-size:clamp(20px,2.2vw,28px); margin:22px 0 8px; }\r\n#ea-page article h3{ font-size:clamp(18px,2vw,22px); margin:16px 0 6px; }\r\n#ea-page article p{ line-height:1.9; margin:12px 0; }\r\n#ea-page article ul, #ea-page article ol{ padding-left:1.2em; }\r\n#ea-page article li{ line-height:1.85; margin:6px 0; }\r\n\r\n#ea-page article blockquote{\r\n  margin:16px 0; padding:16px 18px; background:rgba(255,194,6,.14);\r\n  border-left:4px solid var(--brand); border-radius:10px; color:var(--ink);\r\n}\r\n\r\n/* Table - nice default + RWD wrapper */\r\n#ea-page .table-wrap{\r\n  overflow-x:auto; -webkit-overflow-scrolling:touch;\r\n  border:1px solid var(--border); border-radius:12px; background:#fff; margin:16px 0;\r\n}\r\n#ea-page .table-wrap > table{ margin:0; width:100%; border-collapse:separate; border-spacing:0; }\r\n#ea-page thead th{\r\n  background:linear-gradient(180deg, rgba(19,29,63,.06), rgba(19,29,63,.02));\r\n  color:var(--navy); text-align:left; font-weight:700; padding:12px 14px; border-bottom:1px solid var(--border);\r\n}\r\n#ea-page td, #ea-page th{ padding:12px 14px; border-bottom:1px solid var(--border); vertical-align:top; }\r\n#ea-page tr:last-child td{ border-bottom:none; }\r\n\r\n/* Sidebar */\r\n#ea-page .side{ display:flex; flex-direction:column; gap:18px; }\r\n#ea-page .card{ background:#fff; border:1px solid var(--border); border-radius:16px; padding:18px; }\r\n#ea-page .card h4{ margin:0 0 8px; font-size:16px; color:var(--navy); letter-spacing:.3px; }\r\n#ea-page .muted{ color:var(--muted); font-size:14px; }\r\n\r\n/* Pricing */\r\n#ea-page .pricing{ display:grid; grid-template-columns:1fr; gap:12px; margin-top:8px; }\r\n#ea-page .price-item{ border:1px solid var(--border); border-radius:14px; padding:16px; background:var(--card); }\r\n#ea-page .pi-title{ font-weight:800; margin:0 0 6px; color:var(--navy); }\r\n#ea-page .pi-line{ margin:4px 0 0; }\r\n#ea-page .badge{ display:inline-block; padding:6px 10px; border-radius:999px; font-size:12px; letter-spacing:.3px; background:var(--brand); color:#fff; font-weight:800; }\r\n\r\n/* Buttons */\r\n#ea-page .btn{ appearance:none; border:2px solid var(--brand); border-radius:999px; padding:10px 14px; background:#fff; color:var(--brand); cursor:pointer; font-weight:700; }\r\n#ea-page .btn.btn-primary, #ea-page .btn-primary{ background:var(--brand); color:#fff; border-color:var(--brand); }\r\n#ea-page .btn:focus{ outline:3px solid var(--ring); outline-offset:2px; }\r\n\r\n/* Divider */\r\n#ea-page .divider{ height:1px; background:var(--border); margin:14px 0; }\r\n\r\n/* Media responsiveness */\r\n#ea-page .embed{ position:relative; width:100%; padding-top:56.25%; border-radius:12px; overflow:hidden; border:1px solid var(--border); background:#000; margin:12px 0; }\r\n#ea-page .embed iframe{ position:absolute; inset:0; width:100%; height:100%; border:0; }\r\n\r\n/* -------- RWD Hardening -------- */\r\n#ea-page { overflow-x: hidden; }\r\n#ea-page *, #ea-page *::before, #ea-page *::after { box-sizing: border-box; }\r\n\r\n/* Wrap long text / links */\r\n#ea-page article :is(h1,h2,h3,p,li,td,th),\r\n#ea-page .card,\r\n#ea-page .hero p,\r\n#ea-page a {\r\n  overflow-wrap:anywhere;\r\n  word-wrap:break-word;\r\n  word-break:break-word;\r\n}\r\n\r\n/* Images/videos/iframes full width */\r\n#ea-page img, #ea-page video, #ea-page iframe {\r\n  max-width:100% !important;\r\n  height:auto;\r\n}\r\n\r\n/* Tables: fallback to horizontal scroll if needed */\r\n#ea-page article table { display:block; width:100%; overflow-x:auto; -webkit-overflow-scrolling:touch; }\r\n#ea-page article table th, #ea-page article table td { white-space:normal; }\r\n\r\n/* Kill inline fixed widths that could break RWD */\r\n#ea-page [style*=\"min-width\"] { min-width: 0 !important; }\r\n#ea-page [style*=\"width: \"], #ea-page [style*=\"width:\" ] { max-width: 100% !important; }\r\n\r\n/* Mobile paddings */\r\n@media (max-width: 480px){\r\n  #ea-page .container { padding-left: 16px; padding-right: 16px; }\r\n  #ea-page .hero { padding: 20px; }\r\n  #ea-page article { padding: 18px; }\r\n}\r\n\r\n/* Single column under 960px */\r\n@media (max-width: 959.98px){\r\n  #ea-page .shell { grid-template-columns: 1fr !important; }\r\n}\r\n\r\n/* ---------- Utilities for BS3 gaps we used ---------- */\r\n#ea-page .u-w75 { max-width: 75%; }\r\n#ea-page .u-mx-auto { margin-left:auto; margin-right:auto; }\r\n\r\n/* Spacing helpers (since BS3 lacks mt-5 etc.) */\r\n#ea-page .mt100 { margin-top: 100px; }\r\n#ea-page .mb100 { margin-bottom: 100px; }\r\n#ea-page .mt-5 { margin-top: 3rem; }\r\n#ea-page .w-100 { width:100%; }\r\n/* 作用域變數：設定吸頂距離（導覽列 + topband 高度） */\r\n#ea-page {\r\n  --sticky-top: 80px; /* 依你的站上實際高度調整 */\r\n}\r\n\r\n/* 讓側欄在 grid 裡不要被置中拉扯，卡在頂部起始位置 */\r\n#ea-page .side {\r\n  align-self: start;\r\n}\r\n\r\n/* 真正 sticky 的容器（包住「目錄」和「聯絡我們」兩張卡） */\r\n#ea-page .side-sticky {\r\n  position: sticky;\r\n  top: var(--sticky-top);\r\n  max-height: calc(100vh - var(--sticky-top) - 16px);\r\n  overflow: auto;\r\n  -webkit-overflow-scrolling: touch;\r\n}\r\n\r\n/* 卡片間距 */\r\n#ea-page .side-sticky .card + .card {\r\n  margin-top: 14px;\r\n}\r\n\r\n/* 小螢幕時關掉 sticky（側欄通常會落到主文下方單欄顯示） */\r\n@media (max-width: 959.98px) {\r\n  #ea-page {\r\n    --sticky-top: 0px;\r\n  }\r\n  #ea-page .side-sticky {\r\n    position: static;\r\n    max-height: none;\r\n    overflow: visible;\r\n  }\r\n}\r\n\r\n/* 關鍵：避免祖先誤設 overflow 影響 sticky。\r\n   只允許 X 軸隱藏，Y 軸要保持可滾動 */\r\n#ea-page {\r\n  overflow-x: hidden;   /* ✅ */\r\n  /* 不要寫 overflow: hidden; 會害 sticky 失效 */\r\n}\r\n\r\n/* 若你的 .shell 是 CSS Grid，確保它本身沒有 overflow */\r\n#ea-page .shell,\r\n#ea-page .container {\r\n  overflow: visible;\r\n}\r\n/* ====== Sticky Sidebar — 強制穩定版 ====== */\r\n/* 1) 統一吸頂位移（導覽列 + topband 高度），沒有就用 80px */\r\n#ea-page { --sticky-top: 80px; }\r\n\r\n/* 2) Grid 對齊到上緣，確保 sticky 起始點正確 */\r\n#ea-page .shell { align-items: start; }\r\n\r\n/* 3) 讓 aside 本身就 sticky（比包一層 .side-sticky 更穩） */\r\n#ea-page aside.side {\r\n  position: sticky;\r\n  top: var(--sticky-top, 80px);\r\n  height: max-content;          /* 高度以內容為主，避免被撐滿 */\r\n  z-index: 2;                   /* 防止被內容覆蓋 */\r\n}\r\n\r\n/* 4) 側欄內容太長時，讓卡片本身滾動（可選） */\r\n#ea-page aside.side .card + .card { margin-top: 14px; }\r\n#ea-page aside.side .card-wrap {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 14px;\r\n  max-height: calc(100vh - var(--sticky-top, 80px) - 16px);\r\n  overflow: auto;\r\n  -webkit-overflow-scrolling: touch;\r\n}\r\n\r\n/* 5) 避免祖先不小心設到破壞 sticky 的屬性 */\r\n#ea-page,\r\n#ea-page .container,\r\n#ea-page .shell,\r\n#ea-page article,\r\n#ea-page .content {\r\n  overflow: visible !important;    /* 不能有 overflow: hidden/auto/scroll（Y 軸）*/\r\n  transform: none !important;      /* 不能有 transform 會中斷 sticky 參考 */\r\n  will-change: auto !important;    /* 避免外層被優化成獨立圖層 */\r\n}\r\n\r\n/* 手機單欄就關掉 sticky（側欄會掉到主文下方） */\r\n@media (max-width: 959.98px) {\r\n  #ea-page aside.side {\r\n    position: static;\r\n  }\r\n  #ea-page aside.side .card-wrap {\r\n    max-height: none;\r\n    overflow: visible;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
